<template>
  <div>
    <v-row>
      <v-btn small fab left class="ml-6 my-2" :color="getThemeColor" dark @click="goBack()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </v-row>
    <Loader></Loader>
    <VueHtml2pdf
      :show-layout="false"
      :float-layout="false"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="Students Owing"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="100%"
      ref="html2Pdf"
    >
      <template v-slot:pdf-content>
        <section>
          <div class="invoice-box" id="invoice">
            <table cellpadding="0" cellspacing="0">
              <tr class="top">
                <td colspan="4">
                  <table>
                    <tr>
                      <td class>
                        {{getUserSchool.schname}}
                        <br />
                        {{selectedClass}}
                        <br />
                        {{selDate}}
                      </td>

                      <td>
                        {{getUserSchool.physical_address}}
                        <br />
                        {{getUserSchool.city}}, {{getUserSchool.pcode}}
                        <br />
                        {{getUserSchool.sch_tel}}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>

            <v-card>
              <v-card-title>
                Students Owing
                <v-spacer></v-spacer>
                <v-chip
                  class="ma-2"
                  color="warning"
                  text-color="white"
                >Due: {{getCurrency}} {{classTotalDue}}</v-chip>

                <v-chip
                  class="ma-2"
                  color="green"
                  text-color="white"
                >Paid: {{getCurrency}} {{classTotalPaid}}</v-chip>

                <v-chip
                  class="ma-2"
                  color="red"
                  text-color="white"
                >Outstanding: {{getCurrency}} {{classTotalExpected}}</v-chip>
              </v-card-title>
              <v-data-table
                disable-pagination
                hide-default-footer
                :headers="headers"
                :items="students"
                :search="search"
              ></v-data-table>
            </v-card>
          </div>
        </section>
      </template>
    </VueHtml2pdf>
  </div>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";
import Loader from "@/components/Loader.vue";

export default {
  components: { VueHtml2pdf, Loader },
  mounted() {
    this.$store.commit("setLoader", true);
    this.students = this.$route.params.students;
    this.headers = this.$route.params.headers;
    this.classTotalDue = this.$route.params.classTotalDue;
    this.classTotalPaid = this.$route.params.classTotalPaid;
    this.classTotalExpected = this.$route.params.classTotalExpected;
    this.classObj = this.$route.params.classObj;
    this.selDate = this.$route.params.selDate;
    this.selectedClass = this.$route.params.selectedClass;
    this.$store.commit("setLoader", false);
    this.generateReport();
  },

  data: () => ({
    students: [],
    headers: [],
    search: null,
    selectedClass: null,
    classTotalDue: null,
    classTotalPaid: null,
    classTotalExpected: null,
    classObj: null,
    selDate: null
  }),
  computed: {
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    }
  },
  methods: {
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },

    goBack() {
      this.$router.back();
    }
  }
};
</script>
